import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const ARCHIVED = 'ARCHIVED' as const;
export const RELEASED = 'RELEASED' as const;
export const UNARCHIVED = 'UNARCHIVED' as const;
export const UNRELEASED = 'UNRELEASED' as const;

export const FIRST_COLUMN_MIN_WIDTH = gridSize * 23;

// Link rendered when "latest deployment" section has no recent deployments
export const SUPPORT_DOCS_LINK_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default [ARCHIVED, RELEASED, UNRELEASED, UNARCHIVED];
